import moment from 'moment';

moment.locale('id');

export const thousand = (val = 0) => {
  val =
    val && (typeof val === 'string' || typeof val === 'number')
      ? parseFloat(val)
      : 0;
  if (val % 1 > 0) {
    val = val.toFixed(2);
  }
  return val
    .toString()
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    .replace(/,00$/, '');
};

export const date = (value = '', format = 'DD MMM YYYY') => {
  return value ? moment(value, 'YYYY-MM-DD').format(format) : value;
};

export const formatDate = (dateString, format = 'D MMM YYYY') => {
  if (!dateString) return '-';
  const m = moment(dateString);
  return m.isValid() ? m.locale('id').format(format) : dateString;
};

export const formatDateRange = (start, end, format = 'D MMM YYYY') =>
  !start && !end ? '-' : `${formatDate(start, format)} - ${formatDate(end, format)}`;

export const formatRupiah = (amount) =>
  (amount === undefined || amount === null || amount === '')
    ? 'Rp 0'
    : `Rp ${thousand(amount)}`;

export const formatRupiahInput = (val = '') => {
  const numberString = val.replace(/[^,\d]/g, '').toString();
  const split = numberString.split(',');
  const sisa = split[0].length % 3;
  let rupiah = split[0].substr(0, sisa);
  const ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  if (ribuan) {
    const separator = sisa ? '.' : '';
    rupiah += separator + ribuan.join('.');
  }

  rupiah = split[1] !== undefined ? rupiah + ',' + split[1] : rupiah;
  return rupiah;
};

export const formatDateTime = (value = '', format = 'DD MMM YYYY HH:mm') => {
  return moment(value).isValid()
    ? moment(value).format(format) + ' WIB'
    : value;
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};

export const toDateObject = (value = '') => {
  return moment(value).isValid() ? moment(value).toDate() : null;
};

export const toUpperCase = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const mapping = (data) => {
  return data?.filter((data) => data.value === '*').length === 1 ? []
    : data?.filter((data) => data.value !== '*').map((data) => data.value);
};

export const mappingById = (data) => {
  if(data.length > 0){
    return data?.filter((data) => data === '*').length === 1 ? ''
      : data?.filter((data) => data !== '*');
  }else {
    return '';
  }
};

export function formatBytes(bytes, decimals, binaryUnits) {
  if(bytes === 0) {
    return '0 Bytes';
  }
  let unitMultiple = (binaryUnits) ? 1024 : 1000;
  let unitNames = (unitMultiple === 1024) ?
  // 1000 bytes in 1 Kilobyte (KB) or 1024 bytes for the binary version (KiB)
    ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']:
    ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let unitChanges = Math.floor(Math.log(bytes) / Math.log(unitMultiple));
  return parseFloat((bytes / Math.pow(unitMultiple, unitChanges)).toFixed(decimals || 0)) + ' ' + unitNames[unitChanges];
}

export const formatCountdown = (minutes, seconds) => {
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  const countDownTime = `${formattedMinutes}:${formattedSeconds}`;
  return countDownTime;
};

export const maskEmail = (email) => {
  if (!email) return '';
  const [localPart, domainPart] = email.split('@');
  if (localPart.length < 3) return email;
  const maskedLocalPart = localPart[0] + '*'.repeat(localPart.length - 2) + localPart[localPart.length - 1];
  return `${maskedLocalPart}@${domainPart}`;
};

export const maskingNationalityId = (id) => {
  const nik = String(id);
  if (nik?.length < 7) {
    return nik || '-';
  }

  const firstThreeDigits = nik?.substring(0, 3);
  const lastThreeDigits = nik?.substring(nik.length - 3);
  const maskedDigits = '*'.repeat(nik?.length - 6);

  if (firstThreeDigits && maskedDigits && lastThreeDigits) {
    return `${firstThreeDigits}${maskedDigits}${lastThreeDigits}`;
  } else {
    return null;
  }
};

/**
 * Extracts the file extension from a URL string.
 * @param {string} urlString - The full URL.
 * @returns {string} - The extension (e.g., 'pdf', 'png') or an empty string.
 */
export function getExtensionFromUrl(urlString) {
  try {
    // 1. Use the URL constructor to safely parse the string
    const url = new URL(urlString);

    // 2. Get the pathname (e.g., /path/to/file.pdf)
    const pathname = url.pathname;

    // 3. Find the last dot in the pathname
    const lastDotIndex = pathname.lastIndexOf('.');

    // 4. Return the extension or empty string if no dot exists
    if (lastDotIndex === -1) return '';

    // Extract, remove the dot, and make lowercase
    return pathname.substring(lastDotIndex + 1).toLowerCase();
  } catch (error) {
    return '';
  }
}

/**
 * Converts bytes to a human-readable string (KB, MB, GB, etc.)
 * @param {number} bytes - The total number of bytes.
 * @param {number} decimals - How many points to show after the decimal (default: 2).
 * @returns {string} - The formatted file size.
 */
export const formatFileSize = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  // Calculate the index for the 'sizes' array
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};
